exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-red[data-v-6a7e1f3a]{color:red}.text-orange[data-v-6a7e1f3a]{color:orange}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a7e1f3a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OverdueMaintenanceReference/OverdueMaintenanceReferenceList.vue
// module id = 1076
// module chunks = 0